import { Template } from "@suse-o11y/template";
import { z } from "zod";

import { DEFAULT as DEFAULT_QUERY, type Spec as QuerySpec } from "../../components/widget-form/query/spec";

const FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_PROMQL = DEFAULT_QUERY.promql;
const FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_SPEC = {
	query: FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_PROMQL,
};

const schema = z
	.object({
		kind: z.literal("TimeSeriesQuery"),
		spec: z.object({
			plugin: z
				.object({
					kind: z.literal("PrometheusTimeSeriesQuery"),
					spec: z
						.object({
							query: z
								.string()
								.transform((query) => Template<null>(query))
								.catch(FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_PROMQL),

							alias: z
								.string()
								.transform((query) => Template<null>(query))
								.optional()
								.catch(undefined),

							minStep: z
								.string()
								.transform((query) => Template<null>(query))
								.optional()
								.catch(undefined),
						})
						.catch(FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_SPEC),
				})
				.catch({
					kind: "PrometheusTimeSeriesQuery" as const,
					spec: FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_SPEC,
				}),
		}),
	})
	.transform(({ spec }) => spec.plugin.spec)
	.catch(FALLBACK_PROMETHEUS_TIME_SERIES_QUERY_SPEC);

type TimeSeriesQuery = z.infer<typeof schema>;

function fromQuerySpec(spec: QuerySpec): TimeSeriesQuery {
	return {
		query: spec.promql,
		alias: spec.alias,
		minStep: spec.minStep,
	};
}

function toQuerySpec(query: TimeSeriesQuery): QuerySpec {
	return {
		promql: query.query,
		alias: query.alias,
		minStep: query.minStep,
	};
}

const TimeSeriesQuery = { schema, fromQuerySpec, toQuerySpec };

export { TimeSeriesQuery };
